import { IPagingRequest } from "../../../model/request/IPagingRequest";
import { IThiSinhSelectDanhPhachVmRequest } from "../../../model/request/tct/IThiSinhSelectDanhPhachVmRequest";
import { IPagingResult } from "../../../model/respone/IPagingResult";
import { IThiSinhVm } from "../../../model/respone/tct/IThiSinhVm";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export interface ITuiThiActionTypeBase<T> {
    dotThiId: number,
    data: T
}
export const eTuiThiActionsObj = {
    CHANGE_DOT_THI_ID: {} as ITuiThiActionTypeBase<undefined>,
    CHANGE_MONHOC_SELECTED_IDS: {} as ITuiThiActionTypeBase<number[]>,
    CHANGE_PHONGTHI_SELECTED_IDS: {} as ITuiThiActionTypeBase<number[]>,

    LOAD_THISINH_START: {} as ITuiThiActionTypeBase<IThiSinhSelectDanhPhachVmRequest>,
    LOAD_THISINH_SUCCESS: {} as ITuiThiActionTypeBase<IPagingResult<IThiSinhVm>>,
    LOAD_THISINH_ERROR: {} as ITuiThiActionTypeBase<string>,

    CHANGE_DONG_TUI_MODAL_OPEN: {} as ITuiThiActionTypeBase<boolean>,

    CHANGE_PAGING_REQUEST:{} as ITuiThiActionTypeBase<IPagingRequest>

};
export const eTuiThiActionIds = generateActionTypeIds(
    eTuiThiActionsObj,
    "TUI_THI"
);
export type ITuiThiActionTypes = IGenericActionType<
    typeof eTuiThiActionsObj,
    "TUI_THI"
>;
